import { cleanAxios } from '~/axios'

export async function sendMFAMessageCode({
  phoneNumber,
  accessToken,
}: {
  phoneNumber: string
  accessToken: string
}) {
  return await cleanAxios.post<{
    data: { sendMFAMessageCode: { successful: boolean } }
  }>(
    '/graphql',
    {
      query:
        'mutation sendMFAMessageCode($phoneNumber: String!) { sendMFAMessageCode(phoneNumber: $phoneNumber) { successful } }',
      variables: { phoneNumber },
    },
    { headers: { Authorization: `Bearer ${accessToken}` } },
  )
}
